import React, { useState } from "react";

const Contact = () => {

 const [formData, setFormData] = useState({
    name: "",
    email: "",
    project: "",
    message: "",
  });

  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { placeholder, value } = e.target;
    setFormData({ ...formData, [placeholder.toLowerCase()]: value });

    // Clear error on change
    if (value.trim() !== "") {
      setErrors({ ...errors, [placeholder.toLowerCase()]: "" });
    }
  };

  const handleSendWhatsApp = () => {
    const { name, email, project, message } = formData;
    const newErrors = {};

    if (!name.trim()) newErrors.name = "Name is required";
    if (!email.trim()) newErrors.email = "Email is required";
    if (!project.trim()) newErrors.project = "Project is required";
    if (!message.trim()) newErrors.message = "Message is required";

    setErrors(newErrors);

    if (Object.keys(newErrors).length > 0) return;

    const whatsappMessage =
      `*New Contact Form Submission*\n` +
      `Name: ${name}\n` +
      `Email: ${email}\n` +
      `Project: ${project}\n` +
      `Message: ${message}`;

    const yourNumber = "919277005656";
    const url = `https://wa.me/${yourNumber}?text=${encodeURIComponent(
      whatsappMessage
    )}`;
    window.open(url, "_blank");
  };


  return (
    <div className="container-fluid py-2 mb-5">
      <div className="container">
        <div
          className="text-center mx-auto pb-5 wow fadeIn"
          data-wow-delay=".3s"
          style={{ maxWidth: "600px" }}
        >
          <h5 className="text-primary">Get In Touch</h5>
          <h1 className="mb-3">Contact for any query</h1>
        </div>

        <div className="contact-detail position-relative p-3">
          <div className="row g-5 mb-5 justify-content-center">
            <div className="col-xl-4 col-lg-6 wow fadeIn" data-wow-delay=".3s">
              <div className="d-flex bg-light p-3 rounded">
                <div
                  className="flex-shrink-0 btn-square bg-secondary rounded-circle"
                  style={{ width: 64, height: 64 }}
                >
                  <i className="fas fa-map-marker-alt text-white"></i>
                </div>
                <div className="ms-3">
                  <h4 className="text-primary">Address</h4>
                  <a
                    href="https://goo.gl/maps/Zd4BCynmTb98ivUJ6"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="h5"
                  >
                    Mohali, Punjab, India
                  </a>
                </div>
              </div>
            </div>

            <div className="col-xl-4 col-lg-6 wow fadeIn" data-wow-delay=".5s">
              <div className="d-flex bg-light p-3 rounded">
                <div
                  className="flex-shrink-0 btn-square bg-secondary rounded-circle"
                  style={{ width: 64, height: 64 }}
                >
                  <i className="fa fa-phone text-white"></i>
                </div>
                <div className="ms-3">
                  <h4 className="text-primary">Call Us</h4>
                  <a
                    href="tel:+919277005656"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="h5"
                  >
                    +919277005656
                  </a>
                </div>
              </div>
            </div>

            <div className="col-xl-4 col-lg-6 wow fadeIn" data-wow-delay=".7s">
              <div className="d-flex bg-light p-3 rounded">
                <div
                  className="flex-shrink-0 btn-square bg-secondary rounded-circle"
                  style={{ width: 64, height: 64 }}
                >
                  <i className="fa fa-envelope text-white"></i>
                </div>
                <div className="ms-3">
                  <h4 className="text-primary">Email Us</h4>
                  <a
                    href="mailto:info@aesos.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="h5"
                  >
                    info@aesos.in
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div className="row g-5">
            <div className="col-lg-6 wow fadeIn" data-wow-delay=".3s">
              <div className="p-2 h-100 rounded contact-map">
                <iframe
                  className="rounded w-100 h-100"
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3025.4710403339755!2d-73.82241512404069!3d40.685622471397615!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c26749046ee14f%3A0xea672968476d962c!2s123rd%20St%2C%20Queens%2C%20NY%2C%20USA!5e0!3m2!1sen!2sbd!4v1686493221834!5m2!1sen!2sbd"
                  style={{ border: 0 }}
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="Location Map"
                ></iframe>
              </div>
            </div>

            {/* Contact Form */}
            <div className="col-lg-6 wow fadeIn" data-wow-delay=".5s">
              <div className="p-2 rounded contact-form">
                <div className="mb-4">
                  <input
                    type="text"
                    className={`form-control border-0 py-3 ${errors.name ? "is-invalid" : ""}`}
                    placeholder="Name"
                    value={formData.name}
                    onChange={handleChange}
                  />
                  {errors.name && <div className="invalid-feedback">{errors.name}</div>}
                </div>

                <div className="mb-4">
                  <input
                    type="email"
                    className={`form-control border-0 py-3 ${errors.email ? "is-invalid" : ""}`}
                    placeholder="Email"
                    value={formData.email}
                    onChange={handleChange}
                  />
                  {errors.email && <div className="invalid-feedback">{errors.email}</div>}
                </div>

                <div className="mb-4">
                  <input
                    type="text"
                    className={`form-control border-0 py-3 ${errors.project ? "is-invalid" : ""}`}
                    placeholder="Project"
                    value={formData.project}
                    onChange={handleChange}
                  />
                  {errors.project && <div className="invalid-feedback">{errors.project}</div>}
                </div>

                <div className="mb-4">
                  <textarea
                    className={`w-100 form-control border-0 py-3 ${errors.message ? "is-invalid" : ""}`}
                    rows={6}
                    placeholder="Message"
                    value={formData.message}
                    onChange={handleChange}
                  ></textarea>
                  {errors.message && <div className="invalid-feedback">{errors.message}</div>}
                </div>

                <div className="text-start">
                  <button
                    className="btn bg-primary text-white py-3 px-5"
                    type="button"
                    onClick={handleSendWhatsApp}
                  >
                    Send Message
                  </button>
                </div>
              </div>
            </div>

            
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
